import CustomModal from "@/shared/components/ui/Modal/CustomModal";
import AddCampaignLayout from "../Form/AddCampaignLayout";
import DefinePitch from "@/features/onboarding/components/Onboarding/DefinePitch";
import { X } from "lucide-react";

const PitchModal = ({
  isOpen,
  onClose,
  onSave,
  registerSubmitHandler,
  onDataChange,
  onAssetsChange,
  companyAssets,
  pitchData,
  campaignId,
  isSavingPitch,
}) => (
  <CustomModal isOpen={isOpen} onClose={onClose} width="950px">
    <div className="flex justify-end w-full">
      <button className="p-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors" onClick={onClose}>
        <X size={20} className="text-gray-800 dark:text-gray-200" />
      </button>
    </div>
    <AddCampaignLayout
      variant="modal"
      title="Let's Fine Tune Your Pitch"
      description="Take a moment to review and personalize your pitch."
      cancelButtonText="Cancel"
      saveButtonText="Save"
      saveButtonIcon={false}
      onCancel={onClose}
      onSaveAndNext={onSave}
      isSaving={isSavingPitch}
      children={
        <DefinePitch
          registerSubmitHandler={registerSubmitHandler}
          onDataChange={onDataChange}
          onAssetsChange={onAssetsChange}
          initialCompanyAssets={companyAssets || []}
          initialValues={pitchData}
          key={`pitch-${campaignId}`}
          isEditMode={true}
        />
      }
    />
  </CustomModal>
);

export default PitchModal;
